import { ChannelDiscountDTO } from 'app/back-office/shared/models/back-office-admin-common/channel-discount.model';
import { MediaDTO } from 'app/shared/models/media.models';

import { ProductPallete } from './product-pallete.model';
import { Size } from './size.model';
import { styleGroupDTO } from 'app/shared/models/style-group.model';
import { GenderTypeEnum } from 'app/back-office/shared/enum/gender-type.enum.model';
import { VariantDTO } from 'app/back-office/shared/models/products/variant.models';
import { OrderItemDeliveryDTO } from 'app/shared/models/custom-deliveries.models';

export class ProductVariant extends VariantDTO {
  sizeId: number;
  sizeGroupId: number;
  teamId: number;
  wholesalePrice: number;
  unitRetailPrice: number;
  paletteId: number;
  limitQuantityToOrderFromSupplierDate: string;
  storeSalePeriodFrom: string;
  storeSalePeriodTo: string;
  purchaseLimit: number;
  orderItemId: number;
  quantity: number;
  unitPriceWholesale: number;
  discountedUnitPrice: number;
  storeChannelDiscount: ChannelDiscountDTO;
  label: string;
  inStock: boolean;
  isWhiteCell: boolean;
  requestedDeliveryDate?: string;
  deliveries?: OrderItemDeliveryDTO[];
  gender: GenderTypeEnum;
  quantityMinimumPerOrder: number;
  productStyleGroup: styleGroupDTO;
  customDeliveryId: number;
  styleGroupId: number;

  constructor(s?: ProductVariant) {
    super();
    Object.assign(this, s);
    if (s) {
      if (s.media) this.media = s.media?.map(x => new MediaDTO(x));
      if (s.size) this.size = new Size(s.size);
      if (s.palette) this.palette = new ProductPallete(s.palette);
    }
  }

}

export class PriceComputation {
  appliedStoreChannelDiscountId?: number;
  appliedStoreChannelDiscountPercentage: number;
  appliedStoreChannelDiscountTagId: number;
  computedForCustomerId: number;
  customerPriceOverrideHasBeenApplied: boolean;
  discountedRetailPrice: number;
  discountedWholeSalePrice: number;
  retailPrice: number;
  sourcePriceListId: number;
  storeChannelDiscountHasBeenApplied: boolean;
  wholesalePrice: number;
}

export class ElaboratedCustomDates {
  minDate: string;
  maxDate?: string;
  constructor(init: ElaboratedCustomDates) {
    Object.assign(this, init);
  }
}
